import React from 'react'
import { useTranslation } from 'react-i18next'

import { Block, Item, Title } from './components'

const Byzans: React.FunctionComponent = () => {
    const { t, i18n } = useTranslation('landing')

    const isFrench = i18n.language === 'fr'
    
    return (
        <Block>
            <Title>Byzans</Title>
            <Item target={'_blank'} to={'/policy/terms'}>{t('footer.byzans.terms')}</Item>
            <Item target={'_blank'}  to={'/policy/data'}>{t('footer.byzans.data')}</Item>
            <Item target={'_blank'}  to={'/policy/community'}>{t('footer.byzans.community')}</Item>
            {isFrench ? <Item target={'_blank'}  to={'/policy/mentions'}>{t('footer.byzans.mentions')}</Item> : null}
            <Item target={'_blank'}  to={'/faq'}>{t('footer.byzans.faq')}</Item>
        </Block>
    )
}

export default Byzans